import {handleActions} from 'redux-actions';
import reduce from 'lodash.reduce';

import {DEAL_ALLOCATE_CHANGE, DEAL_ALLOCATE_LOAD} from 'flows/deal/allocate';
import {selectAllocate} from '../selectors';

import Big from 'big.js';

// Selectors
export const selectDealAllocations = store => selectAllocate(store);

export const initialState = {};

export const reducer = handleActions({
  [DEAL_ALLOCATE_CHANGE.PERSIST]: (state, action) => ({
    ...state,
    [action.payload.allocation.id]: Big(action.payload.allocated).times(Big(100)).toString(),
  }),
  [DEAL_ALLOCATE_LOAD.ACTION]: (state, action) => {
    const transform = (acc, allocation) => ({
      ...acc,
      [allocation.id]: Big(allocation.investment.allocated || allocation.investment.amount).toString(),
    });
    return reduce(action.payload.allocations, transform, {});
  },
}, initialState);



// WEBPACK FOOTER //
// ./mobile/shared/flows/deal/allocate/reducer.js